module.exports = __webpack_public_path__ + "img/gwjj.e5f3c61c.svg";